import { defineStore } from 'pinia'
import moment from 'moment'

export const timelineStore = defineStore('timelineStore', {
	state: () => {
		return {
			timelineDiscript: {}, // 时间线描述
			activeCardIndex: 0, // 当前活动卡片
			isPlaying: false, // 是否播放
			isLoading: false, // 是否在加载资源
			timePoint: 0, // 当前时间点
			activeClipName: '', // 当前选中的clip
			templateStyle: 'across', // across 横版 down 竖版
			templateName: '未命名文件' + moment().format('YYYYMMDD HH:mm:ss'), // 模板名称
			templateId: '', // 模板id 用于保存 更新使用
			templateType: '', // draft 草稿 template 模板
			aiHumans: [], // 数字人数组
			editorLoaded: false, // editor初始化完成 并初始化渲染完成 可使用editor全部功能
			showClipTimeLine: false, // 是否显示clip时间线
			captionStyle: {
				font: 'https://source.wengegroup.com/mam2/6162da06e4b0726539a4450f.otf',
				size: 40,
				color: '#fff'
			}, // 字幕风格
			theme: 'dark', // dark || light
			resetAudio: {}, // 重写audio对象
			activeAiHuman: {}, // 当前活动数字人
			audioUrl: '', // 音频
			globalAudio: {
				audioVolume: 50,
				res_path: '',
				audioName: '',
				end_action: 2,
				id: ''
			}, // 全局音乐
			changeId: false,
			translateCardName: '', // 唯一卡片名称
			currentVoice: {
				speed: 1, //语音速度
				voiceName: 'molingying_meet_24k@newscast', //音色
				voiceNum: 50 //音色
			}, // 旁白音色
			globalTask: '', // 任务task
			globalTitle: '', // 全局标题
			timeLineMediaList: [], // 视频列表
			frontCover: '', // 视频封面
			webStatusInfo: {
				activeMusicObj: {},
				activeVoiceObj: {},
				textArr: []
			}, // 全局状态
			preViewMediaInfo: {
				show: false,
				mediaUrl: ''
			}
		}
	},
	getters: {
		getCardName: state => {
			if (state.timelineDiscript.model) {
				return state.timelineDiscript.model.card_list[state.activeCardIndex].id
			}
		},
		getActiveCard: state => {
			if (state.timelineDiscript.model) {
				return state.timelineDiscript.model.card_list[state.activeCardIndex]
			}
			return []
		},
		getCardList: state => {
			if (state.timelineDiscript.model) {
				return state.timelineDiscript.model.card_list
			}
		},
		getTransitionList: state => {
			if (state.timelineDiscript.model) {
				return state.timelineDiscript.model.transition_list
			}
		},
		// 获取当前选中活动的对象
		getTopClipObj: state => {
			if (!state.getActiveClipList) return
			const findData = state.getActiveClipList.find(d => d.id === state.activeClipName)
			if (findData) {
				return findData
			} else {
				return undefined
			}
		},
		getActiveClipList: state => {
			if (state.timelineDiscript.model) {
				return state.timelineDiscript.model.card_list[state.activeCardIndex].track_list[0].clip_list
			}
			return []
		},
		// 获取当前数字人信息
		getCurrentHuman: state => {
			let activeAiHuman = {}
			state.aiHumans.map(ite => {
				if (ite.card_id === state.getCardName) {
					activeAiHuman = ite
				}
			})
			return activeAiHuman
		},
		// 要保存的信息
		getSave: state => {
			return {
				timelineDiscript: state.timelineDiscript,
				aiHumans: state.aiHumans,
				templateStyle: state.templateStyle,
				templateName: state.templateName
			}
		},
		// 当前数字人
		getActiveAi: state => {
			let activeAi = {}
			state.getActiveClipList.map(item => {
				if (item.id.split('_')[1] === 'ai') {
					activeAi = item
				}
			})
			return activeAi
		},
		getTimelineDiscript: state => {
			return state.timelineDiscript
		},
		getActiveClipListZindex: state => {
			let maxZindex = 0
			if (!state.getActiveClipList) return maxZindex
			state.getActiveClipList.forEach(clip => {
				if (clip.zIndex > maxZindex && clip.zIndex < 9999) {
					maxZindex = clip.zIndex
				}
			})
			return maxZindex
		},
		getEditorLoaded: state => {
			return state.editorLoaded
		},
		// 当前活动的卡片时长
		getActiveCardDuration: state => {
			return state.getActiveCard.duration
		},
		getTimePoint: state => {
			return state.timePoint
		},
		getIsPlaying: state => {
			return state.isPlaying
		},
		// 获取当前卡片之前 所有卡片的总时长
		getAllCardsDurationBeforeActive: state => {
			let duration = 0
			for (let index in state.getCardList) {
				if (index < state.activeCardIndex) {
					duration += state.getCardList[index].duration
				} else {
					return duration
				}
			}
		},

		// 获取所有卡片时长
		getAllCardsDuration: state => {
			let duration = 0
			for (let index in state.getCardList) {
				duration += state.getCardList[index].duration
				console.log(state.getCardList[index].duration, 'dfdddddddd')
			}
			return duration
		},

		getActiveClipName: state => {
			return state.activeClipName
		},

		getShowClipTimeLine: state => {
			return state.showClipTimeLine
		},
		// 获取当前clip在aihuman 中的映射
		getAihuamByClip: state => {
			let human = {}
			state.aiHumans.map(ite => {
				if (ite.card_id === state.getCardName && ite.clip_list) {
					ite.clip_list.map(o => {
						if (o.id === state.getActiveClipName) human = o
					})
				}
			})
			return human
		},
		// 获取当前card的clip列表在aiHuman中的 映射
		getAiHuamListByCard: state => {
			let human = []
			state.aiHumans.map(ite => {
				if (ite.card_id === state.getCardName) human = ite.clip_list
			})
			return human
		},
		// 获取当前card的bgId
		getBgClip: state => {
			const obj = state.getAiHuamListByCard.filter(ite => ite.id.split('_')[1] === 'background')
			return obj
		}
	},
	actions: {
		// 根据clipname获取在aihuams中的映射
		getAiHuamListByClipName(name) {
			let human = ''
			this.aiHumans.map(ite => {
				if (ite.card_id === this.getCardName) {
					ite.clip_list.map(o => {
						if (o.id === name) human = o
					})
				}
			})
			return human
		},
		// 更新humans中的duration
		updataAihuamByClip(obj) {
			const arr = this.aiHumans.map(ite => {
				if (ite.card_id === this.getCardName) {
					ite.clip_list.map(o => {
						if (o.id === obj.clip_name) {
							o.sequenceIn = obj.sequenceIn
							o.sequenceOut = obj.sequenceOut
						}
						return o
					})
				}
				return ite
			})
			this.aiHumans = arr
		},
		// 更新aihuams
		updataAiHumans(item) {
			const nweGroup = this.aiHumans.map(ite => {
				// ai_anchorId 判断如果多个卡片 用同一个数字人 会造成覆盖 暂时用cardid
				// TODO cardid 如果一个卡片多个数字人会全部覆盖
				if (ite.card_id === item.card_id) {
					ite = item
				}
				return ite
			})
			this.aiHumans = nweGroup
		},
		// 更新时间线
		updateTimelineDiscript(discript) {
			this.timelineDiscript = discript
		},
		setIsPlaying(data) {
			this.isPlaying = data
		},
		// 更新时间
		setTimePoint(data) {
			this.timePoint = data
		},
		// 更新活动卡片时长
		// 更新顶层clipname
		setActiveClipName(data) {
			this.activeClipName = data
		},
		// 更新活动卡片index
		setActiveCardIndex(index) {
			this.activeCardIndex = index
		},
		setActiveAiHuman(data) {
			const arr = this.aiHumans.map(ite => {
				if (ite.card_id === data.card_id) {
					ite = data
				}
				return ite
			})
			this.aiHumans = arr
		},
		// 更改图层顺序
		setLayerOrder(type) {
			let dataArr =
				this.timelineDiscript.model.card_list[this.activeCardIndex].track_list[0].clip_list
			let activeItem = {}
			let activeIndix = null
			let dataArrNew = dataArr
			// dataArr.map((item, idx) => {
			//   if (item.id === this.getTopClipObj.id) {
			//     activeItem = item;
			//     activeIndix = idx;
			//   }
			//   return item;
			// });
			for (let index = 0; index < dataArr.length; index++) {
				const element = dataArr[index]
				if (element.id === this.getTopClipObj.id) {
					activeItem = element
					activeIndix = index
				}
			}
			// 转变图层顺序 0置顶1上移2下移3置地
			switch (type) {
				case 0:
					dataArrNew.splice(activeIndix, 1)
					dataArrNew.push(activeItem)
					break
				case 1:
					// 判断要交换位置的元素是否是数组的最后一个元素，如果是则不进行交换
					if (activeIndix < dataArrNew.length - 1) {
						// js 将数组中的任意一个item与他后面一位item交换位置
						dataArrNew.splice(activeIndix, 2, dataArrNew[activeIndix + 1], dataArrNew[activeIndix])
					}
					break
				case 2:
					// 判断要交换位置的元素是否是数组的第一个元素，如果是则不进行交换
					if (activeIndix > 0) {
						// 使用 splice() 方法交换要交换位置的元素和它前面的一个元素的位置
						dataArrNew.splice(
							activeIndix - 1,
							2,
							dataArrNew[activeIndix],
							dataArrNew[activeIndix - 1]
						)
					}
					break
				case 3:
					dataArrNew.splice(activeIndix, 1)
					dataArrNew.unshift(activeItem)
					break
				default:
					break
			}
			// const arr = dataArrNew.map(m => { return m.id })
			// arr.forEach((m, k) => {
			//   if (this.getTopClipObj.id === m) {
			//     state.mediaId = k
			//   }
			// })
			// 过滤 无用素材
			const trueArr = dataArrNew.filter(m => m.id !== undefined)
			this.timelineDiscript.model.card_list[this.activeCardIndex].track_list[0].clip_list = trueArr
			dataArr = trueArr
		},
		setGlobalAudio(obj) {
			const { audioVolume, res_path, audioName, id } = obj
			this.globalAudio.audioVolume = audioVolume
			this.globalAudio.res_path = res_path
			this.globalAudio.audioName = audioName
			this.globalAudio.end_action = 2
			this.globalAudio.id = id
		},
		setTheme(theme) {
			this.theme = theme
		},

		setEditorLoaded(editorLoaded) {
			this.editorLoaded = editorLoaded
		},

		setShowClipTimeLine(showClipTimeLine) {
			this.showClipTimeLine = showClipTimeLine
		}
	}
})
